import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { setActiveSeasons } from '../../utils/filter/timePeriods';
import fixMobileSafariWhiteScreenBug from '../../utils/fixMobileSafariWhiteScreenBug';
import analyticsPage from '../../analyticsPage';

class PageProvider extends PureComponent {
    constructor(props) {
        super(props);

        const data = window.PRELOADED_STATE;
        delete window.PRELOADED_STATE;

        this.state = { data };

        setActiveSeasons(data.seasons);

        analyticsPage(data);
    }

    componentDidMount() {
        fixMobileSafariWhiteScreenBug();
    }

    componentDidUpdate() {
        fixMobileSafariWhiteScreenBug();
    }

    render() {
        const { route: { Page }, location, children } = this.props;
        const [type, id, name, tab, subTab] = location.pathname.split('/');
        const { hash } = location;

        return (
            <Page
                data={this.state.data}
                params={{ type, id, name, tab, hash, subTab }}
            >
                {children}
            </Page>
        );
    }
}

PageProvider.propTypes = {
    route: PropTypes.shape({
        Page: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }).isRequired,
    children: PropTypes.node.isRequired,
};

export default PageProvider;




// WEBPACK FOOTER //
// ./src/js/shared/providers/PageProvider.jsx